// Shared constants/helpers for the Recycle Bin feature. Keep this in sync
// with TRASH_RETENTION_DAYS in functions/purgeTrash.js — that's the
// server-side job that actually enforces the 7-day limit (see its header
// comment for why the client can't be the sole enforcer of this).
export const TRASH_RETENTION_DAYS = 7;

// Firestore Timestamp -> Date, tolerant of a serverTimestamp() write that
// hasn't round-tripped from the server yet (reads back as null locally
// until the snapshot syncs, per the Firestore SDK docs).
function toDate(deletedAt) {
  if (!deletedAt) return null;
  return typeof deletedAt.toDate === 'function' ? deletedAt.toDate() : new Date(deletedAt);
}

const DAY_MS = 24 * 60 * 60 * 1000;

// Whole days left before an item trashed at `deletedAt` is auto-purged.
// Returns null if deletedAt hasn't synced back yet (rare — only in the
// instant right after the write, before onSnapshot fires again) or if the
// item isn't trashed at all.
export function daysRemaining(deletedAt) {
  const d = toDate(deletedAt);
  if (!d) return null;
  const msLeft = d.getTime() + TRASH_RETENTION_DAYS * DAY_MS - Date.now();
  return Math.max(0, Math.ceil(msLeft / DAY_MS));
}

export function formatDaysRemaining(deletedAt) {
  const n = daysRemaining(deletedAt);
  if (n === null) return 'just now';
  if (n === 0) return 'today';
  if (n === 1) return '1 day';
  return `${n} days`;
}
